module.exports = __webpack_public_path__ + "static/media/pandaparty-tab.d5ed9e89.png";